/** Картинка из буфера обмена. Если там есть и текст (копия из Word, Excel), вставляем текст:
 *  картинкой в таких буферах лежит снимок того же фрагмента. */
export const imageFromPaste = (event: ClipboardEvent): File | null => {
  const data = event.clipboardData
  if (!data || data.getData('text/plain')) return null
  return Array.from(data.files).find((file) => file.type.startsWith('image/')) ?? null
}
